var map = {
	"./ai/compare.svg": 24288,
	"./ai/error.svg": 60047,
	"./ai/summarize.svg": 88650,
	"./ai/trend.svg": 87748,
	"./axis.svg": 52569,
	"./bar/chart0.svg": 12040,
	"./bar/chart1.svg": 24409,
	"./bar/chart2.svg": 75114,
	"./column/chart0.svg": 4183,
	"./column/chart1.svg": 32998,
	"./column/chart2.svg": 32133,
	"./fill/chart0.svg": 15212,
	"./fill/chart1.svg": 50669,
	"./fill/chart2.svg": 56302,
	"./funnel/chart0.svg": 48597,
	"./gauge/chart0.svg": 97466,
	"./line/chart0.svg": 4039,
	"./line/chart1.svg": 64502,
	"./line/chart2.svg": 77461,
	"./pie/chart0.svg": 13783,
	"./pie/chart1.svg": 26246,
	"./pie/chart2.svg": 25381,
	"./radar/chart0.svg": 67269,
	"./radar/chart1.svg": 16100,
	"./radar/chart2.svg": 59223,
	"./scatter/chart0.svg": 63615,
	"./scatter/chart1.svg": 25678,
	"./type.svg": 86098
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78830;